import { render, staticRenderFns } from "./RecipeCategories.vue?vue&type=template&id=02ce09ad&"
import script from "./RecipeCategories.vue?vue&type=script&lang=js&"
export * from "./RecipeCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports